import { Observable } from 'rxjs';
import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { MDocument } from '@argalis-apps/models';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { MGridSettings } from "@argalis-apps/models";
import { StatePersistingService } from "../../services/grid-state/grid-state.service";
import { State, process } from "@progress/kendo-data-query";
import { filterClearIcon, fileExcelIcon, moreHorizontalIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-ags-kendo-grid-list',
  templateUrl: './kendo-grid-list.component.html',
  styleUrls: ['./kendo-grid-list.component.scss']
})
export class KendoGridListComponent implements OnInit {
  
  public gridView: GridDataResult;
  public loading: boolean = true;
  public gridSettings: MGridSettings.IGridSettings;
  public sizes = [5, 10, 20, 50];
  public titlefield: string;
  public table: string;
  public data: any[];
  public selectable = false;
  public svgFilterClear: SVGIcon = filterClearIcon;
  public svgExcel: SVGIcon = fileExcelIcon;
  public svgHorizontal: SVGIcon = moreHorizontalIcon;
  public buttonCount = 5;

  constructor(
    private persistingService: StatePersistingService,
    private router: Router
  ) {}

  ngOnInit() {
    const gridSettings: MGridSettings.IGridSettings = this.persistingService.get(`${this.table}-gridSettings`);
    if (gridSettings !== null) {
      this.gridSettings = this.persistingService.mapGridSettings(gridSettings);
    }
    this.allData = this.allData.bind(this);
  }

  @Input('titlefield')
  set _titlefield(value: string) {
    this.titlefield = value || '';
  }
  @Output() selectedLigne = new EventEmitter<number>();

  @Input('gridConfig')
  set _gridConfig(value: MGridSettings.IGridSettings) {
    this.gridSettings = value;
  }

  @Input()
  public downloadFunction: (id: number, table: string) => Observable<MDocument.IDocumentPresignedResponse>;

  @Input()
  public gotoFunction: (id: number) => void;


  @Input('table')
  set _table(value: string) {
    this.table = value;
  }

  @Input('data')
  set _data(value: any[]) {
    this.data = value || [];
    this.loadDataGrid();
    this.loading = false;
  }

  public get savedStateExists(): boolean {
    return !!this.persistingService.get(`${this.table}-gridSettings`);
  }

  public onResize(e: any): void {
    e.forEach(item => {
      this.gridSettings.columnsConfig.find(col => col.field === item.column.field).width = item.newWidth;
      });
    this.saveGridSettings();
  }

  public onReorder(e: any): void {
    const reorderedColumn = this.gridSettings.columnsConfig.splice(e.oldIndex, 1);
    this.gridSettings.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
    this.saveGridSettings();
  }

  public onVisibilityChange(e: any): void {
    e.columns.forEach(item => {
        this.gridSettings.columnsConfig.find(col => col.field === item.field).hidden = item.hidden;
    });
    this.saveGridSettings();
  }

  public saveGridSettings(): void {
    const gridConfig = {
      state: this.gridSettings.state,
      columnsConfig: this.gridSettings.columnsConfig,
    };
    this.persistingService.set(`${this.table}-gridSettings`, gridConfig);
  }

  public clearFilters() {
    this.gridSettings.state.filter = {
      logic: "and",
      filters: [],
    };
    this.saveGridSettings();
    this.loadDataGrid();
  }

  private loadDataGrid(): void {
    this.gridView = process(this.data, this.gridSettings.state);
  }

  public allData(): ExcelExportData {
    var myState : State = this.gridSettings.state;
    myState.skip = 0;
    myState.take = this.data.length;
    const result: ExcelExportData =  {
        data: process(this.data, myState).data,
        group: myState.group
    };
    return result;
  }

  public dataStateChange(state: State): void {
    this.gridSettings.state = state;
    this.saveGridSettings()
    this.loadDataGrid();
  }

  public downloadDoc(ind: number) {
    return this.downloadFunction(ind, this.table).subscribe(res => {
      res.url.forEach((presignedUrl: string) => {
        window.open(presignedUrl); // ouvre tous les documents.
      });
    });
  }

  public goTo(id: any) {
    return this.gotoFunction(id);
  }
}
